import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	modalLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	modalLabel: {
		id: 'command-palette.modal.modal-label',
		defaultMessage: 'Command palette modal',
		description: 'The aria label for the command palette modal',
	},
});
